export default {
    data() {
        return {
            warningClass: function(items) { return items['archivo_plano/planilla'] !== null ? true : false },
            tableGBoptions: {},

            tableGBSearch: ['archivo_plano/documento', 'datos_afiliado/name', 'list_novedad/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', btn: 'Generar', msjBtn: 'Generar archivo plano' },
                    tbody: { td: ['archivo_plano/tipodocumento', 'archivo_plano/documento'], campos: ['archivo_plano/documento', 'archivo_plano/aporte', 'archivo_plano/codigoccf', 'archivo_plano/tipo', 'archivo_plano/id_list_novedad', 'archivo_plano/id_datos_afiliado', 'archivo_plano/id_info_afiliacion'] }
                },
                {
                    thead: { th: 'Nombres', sort: null, sortTable: 'datos_afiliado/name', },
                    tbody: { td: ['datos_afiliado/name'] }
                },
                {
                    thead: { th: 'Servicios', },
                    tbody: { td: ['archivo_plano/servicios'] }
                },
                {
                    thead: { th: 'Salario', },
                    tbody: { td: ['archivo_plano/salario'] }
                },
                {
                    thead: {
                        th: 'Novedad',
                        sort: null,
                        sortTable: 'list_novedad/name',

                    },
                    tbody: {
                        td: ['archivo_plano/id_list_novedad'],
                        ftn: function Periodo(value) {
                            switch (value) {
                                case 1:
                                    return 'INGRESO'
                                    break
                                case 2:
                                case 4:
                                    return 'COTIZACIÓN'
                                    break
                                case 3:
                                    return 'RETIRO'
                                    break
                            }
                        }
                    }
                },
                {
                    thead: { th: 'Días', },
                    tbody: { td: ['archivo_plano/dias'] }
                },
                {
                    thead: { th: 'Aporte', },
                    tbody: { td: ['archivo_plano/aporte'] }
                },
                {
                    thead: { th: 'Exon', },
                    tbody: { td: ['archivo_plano/exonerado'] }
                },
            ],

        }
    },
}